var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgButtonNone(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "22px",
    height: "22px",
    viewBox: "0 0 22 22",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "MetinBoyutu-Kucuk") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "path-1",
    x: 0,
    y: 0,
    width: 22,
    height: 22
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "KIT",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Elementler-KIT",
    transform: "translate(-716.000000, -2579.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "MetinBoyutu-Kucuk",
    transform: "translate(716.000000, 2579.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Mask"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.96875,16.46875 L9.0859375,13.296875 L13.453125,13.296875 L14.59375,16.46875 L16.578125,16.46875 L12.3046875,5 L10.2734375,5 L6,16.46875 L7.96875,16.46875 Z M12.9609375,11.6875 L9.6328125,11.6875 L10.6640625,8.7109375 C10.9348958,7.95052083 11.140625,7.25 11.28125,6.609375 C11.3333333,6.81770833 11.4283854,7.14583333 11.5664062,7.59375 C11.7044271,8.04166667 11.8125,8.36979167 11.890625,8.578125 L11.890625,8.578125 L12.9609375,11.6875 Z",
    id: "A",
    fill: "#464646",
    fillRule: "nonzero",
    mask: "url(#mask-2)"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgButtonNone);
export default __webpack_public_path__ + "static/media/Button-None.7f75a64187c39c91a1ef211a94f4e77f.svg";
export { ForwardRef as ReactComponent };